"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getInlineElementAtNode_1 = require("./getInlineElementAtNode");
var getLeafNode_1 = require("../utils/getLeafNode");
/**
 * Get the first inline element inside the given node
 */
function getFirstInlineElement(rootNode) {
    // getFirstLeafNode can return null for empty container
    // do check null before passing on to get inline from the node
    var node = getLeafNode_1.getFirstLeafNode(rootNode);
    return node ? getInlineElementAtNode_1.default(rootNode, node) : null;
}
exports.getFirstInlineElement = getFirstInlineElement;
/**
 * Get the last inline element inside the given node
 */
function getLastInlineElement(rootNode) {
    // getLastLeafNode can return null for empty container
    // do check null before passing on to get inline from the node
    var node = getLeafNode_1.getLastLeafNode(rootNode);
    return node ? getInlineElementAtNode_1.default(rootNode, node) : null;
}
exports.getLastInlineElement = getLastInlineElement;
//# sourceMappingURL=getFirstLastInlineElement.js.map